import { useLocation, Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

const labels = {
  dashboard: 'Dashboard',
  employees: 'Employees',
  attendance: 'Attendance',
  leave: 'Leave',
  overtime: 'Overtime',
  'short-leave': 'Short Leave',
  loans: 'Loans',
  advances: 'Advances',
  payroll: 'Payroll',
  reports: 'Reports',
  audit: 'Audit Log',
  settings: 'Settings',
  company: 'Company',
  users: 'Users',
  departments: 'Departments',
  designations: 'Designations',
  'pay-grades': 'Pay Grades',
  holidays: 'Holidays',
  'leave-types': 'Leave Types',
  'salary-components': 'Salary Components',
  'tax-tables': 'Tax Tables',
  'mid-month': 'Mid-Month',
  new: 'New',
  edit: 'Edit',
};

export function Breadcrumbs() {
  const { pathname } = useLocation();
  const parts = pathname.split('/').filter(Boolean);
  let acc = '';
  return (
    <nav className="flex items-center gap-1 text-xs text-slate-500">
      <Link to="/dashboard" className="hover:text-slate-700 dark:hover:text-slate-300 inline-flex items-center gap-1">
        <Home className="h-3.5 w-3.5" />
      </Link>
      {parts.map((p, i) => {
        acc += '/' + p;
        const label = labels[p] || (Number.isFinite(Number(p)) ? `#${p}` : p);
        const isLast = i === parts.length - 1;
        return (
          <span key={acc} className="inline-flex items-center gap-1">
            <ChevronRight className="h-3 w-3" />
            {isLast ? (
              <span className="font-medium text-slate-700 dark:text-slate-300">{label}</span>
            ) : (
              <Link to={acc} className="hover:text-slate-700 dark:hover:text-slate-300">{label}</Link>
            )}
          </span>
        );
      })}
    </nav>
  );
}
